<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/grocers/${this.$route.params.id}/goods/${this.$route.params.goods_id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/grocers/${this.$route.params.id}/goods/${this.$route.params.goods_id}/edit`,
                    },
                    {
                        title: 'Категории',
                        url: `/grocers/${this.$route.params.id}/goods/${this.$route.params.goods_id}/categories`,
                    },
                ],
            };
        },
    };
</script>
